module.exports = __webpack_public_path__ + "img/big_teacher.f566358b.png";